import type { Values } from '.';

type ApiObject = { step: string | null };

const forFlow = (apiObject: ApiObject) => ({
  type: 'exit_loop',
  loopStepId: apiObject?.step ?? null,
  hasError: false,
});

const forApi = (step: { details: Values }) => ({
  details: {
    step: step.details?.loopStepId ?? null,
  },
});

export const exitLoopDTO = {
  forApi,
  forFlow,
};
